import { Offcanvas } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .offcanvas' ) )
     .forEach( offcanvasNode => new Offcanvas( offcanvasNode ) )
